var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-brand-secondary",attrs:{"id":"NotLoggedIn"}},[(_vm.loadingAuthLink)?_c('div',[_c('b-spinner',{staticClass:"brand-primary"})],1):_c('div',[_c('Login')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }